import moment from 'moment-timezone';
import {
  BOB_FORMS_REQUEST,
  BOB_FORMS_FAILURE,
  BOB_FORMS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function bobFormRequest() {
  return {
    type: BOB_FORMS_REQUEST,
  };
}

function bobFormSuccess(data, token = null) {
  return {
    type: BOB_FORMS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function bobFormError(message) {
  return {
    type: BOB_FORMS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchBobForms(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(bobFormRequest());
    if (!fresh) {
      let bobFormData = {};
      try {
        bobFormData = JSON.parse(getItem(`${config.get('appName')}.bobForms`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !bobFormData.data ||
        config.get('version') !== bobFormData.version ||
        moment().isAfter(moment(bobFormData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(bobFormSuccess(bobFormData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/bob/forms/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((d) => {
        let data = [];
        if (d) data = d;
        try {
          setItem(`${config.get('appName')}.bobForms`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(bobFormSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, bobFormError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/bobForms.js